<wbo-report-page #reportPage [formGroup]="reportPage.formGroup">
    <fui-formation-group class="basic-group no-header">
        <fui-rows>
            <fui-row [label]="'wbo.report.edit.formation.dateSelection'">
                <wbo-date-range-report-criteria></wbo-date-range-report-criteria>
            </fui-row>
            <fui-row [label]="'wbo.report.edit.options'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-detail-report-criteria></wbo-detail-report-criteria>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <wbo-account-report-selection></wbo-account-report-selection>
            </fui-row>
            <fui-row *ngIf="Plugin.LOYALTY | booleanConfig">
                <wbo-membership-type-report-selection></wbo-membership-type-report-selection>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
</wbo-report-page>
